<template lang="pug">
div
  //- template(v-if="showMobile")
  //-   topbar
  //-   .conbox
  //-     .hometabs
  //-       tabs
  //- .tabbox
  //-   .gbox-wrap.contact.aaa
  template(v-if="fixed")
    .contact-wrap
      .contactbox
        .ctbox-top(v-if="!isEmpty")
          template(v-for="(item, key, index) in contactList")
            .ctbox(v-if="item.social_link!==null && fixList.includes(item.social_platform)") 
              a(v-if="item.social_platform!=='livechat'" :href="item.social_link" target="_blank")
                img(:src="'/images/blog/c-'+item.social_platform+'.png'")
                span.text-capitalize {{item.social_platform}}
              a(v-else href="javascript:void(0)" @click="openChat")
                img(:src="'/images/blog/c-'+item.social_platform+'.png'")
                span.text-capitalize {{item.social_platform}}
        .ctbox-con(v-if="content")
          .ctbox-info
            .iimg
              img(src='/images/blog/superstar_icon.png')
            .ccon
              p {{$tc('ui.custom_description.home_title3')}}
              span {{$tc('ui.custom_description.home_description3')}}
          .ctbox-info
            .iimg
              img(src='/images/blog/b2c_icon.png')
            .ccon
              p {{$tc('ui.custom_description.home_title4')}}
              span {{$tc('ui.custom_description.home_description4')}}
  template(v-else)
    template(v-for="(item, key, index) in contactList")
      a(v-if="item.social_link!==null && item.social_platform !='livechat'" :href="item.social_link" target="_blank")
        img(:src="'/images/follow/'+item.social_platform+'.png'")
</template>
<script>
import config from '@/config'
import errorTags from '@/errorTags'
import topbar from '@/views/default/_topBar.vue'
import tabs from '@/views/default/_tabs.vue'
export default {
  components:{
    topbar,
    tabs
  },
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    content: {
      type: Boolean,
      default: true
    },
  },
  data(){
    return{
      contactList: {},
      feedback: {
        status: "",
        success: ""
      },
      fixList:[
        "facebook", "instagram", "livechat", "telegram", "whatsapp", "youtube"
      ],
      footerOrder:["facebook", "instagram", "youtube", "telegram","blogger","tiktok","whatsapp"]
    }
  },
  computed: {
    isEmpty() {
      var keys = Object.keys(this.contactList);
      for(var i = 0; i < keys.length; i++) {
        if(this.contactList[keys[i]]) {
          return false;
        }
      }
      return true;
    }
  },
  created(){
    this.checkSize()
    
  },
  mounted(){
    var vm = this
    $(window).resize(function () {
      vm.checkSize()
    });
    this.getContactUsList()
  },
  methods:{
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
    openChat(){
      LiveChatWidget.call("maximize");
    },
    getContactUsList() {
      var json = {
        brand_code: "epic_cash_my"
      }
      var url = config.getContactUsList();
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }

              this.feedback.status = response.status;

              if (this.feedback.success == true) {
                this.contactList = response.data.value;
                // console.log(this.contactList)
                if(this.fixed === false){
                  this.contactList.sort((a, b) => {
                    // Get the indices of the social platforms in sortOrder array
                    const indexA = this.footerOrder.indexOf(a.social_platform);
                    const indexB = this.footerOrder.indexOf(b.social_platform);

                    // If both platforms are found, sort according to their order in sortOrder
                    if (indexA !== -1 && indexB !== -1) {
                        return indexA - indexB;
                    }

                    // If only one of the platforms is found, it should come before the unfound one
                    if (indexA === -1) return 1;
                    if (indexB === -1) return -1;

                    // If neither is found, keep the original order
                    return 0;
                  });
                }
                // var test = this.isEmpty;
              } else {
                var vm = this;
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$t("ui.attention"), vm.$t("message.list." + response.status), "info", this);
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            var vm = this;
            this.$helpers.showDialog(
              vm.$tc("ui.attention"),
              vm.$tc("message.list." + response.status),
              "info",
              this
            );
          }
        },
        function(response) {
          // this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          var vm = this;
          this.$helpers.showDialog(
            vm.$tc("ui.attention"),
            vm.$tc("message.list." + response.status),
            "info",
            this
          );
        }
      );
    },
  }
}
</script>